import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class ParticipationModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'id': id;
		'partial': string;
		'availabilityIsFinal': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'publishedAt[before]': id;
		'publishedAt[strictly_before]': id;
		'publishedAt[after]': id;
		'publishedAt[strictly_after]': id;
		'participationAvailabilities.date[before]': id;
		'participationAvailabilities.date[strictly_before]': id;
		'participationAvailabilities.date[after]': id;
		'participationAvailabilities.date[strictly_after]': id;
		'daisukiCount': id;
		'figure': id;
		'figure.figureProfessions.profession': id;
		'participationTags.tag': id;
		'participationTaxonomies.taxonomy': id;
		'participationTaxonomies.position': string;
		'participationPartnerships.partnership': id;
		'websiteEntertainment': id;
		'participationStatus': string;
		'slug': id;
	};

	private declare _tsSorts: {
		'id': string;
		'figure.name': string;
		'daisukiCount': string;
		'position': string;
		'createdAt': string;
		'updatedAt': string;
		'publishedAt': string;
	};

	static get path(): string {
		return 'participations/{?id}';
	}

	@doc.string declare slug: string;
	@doc.number declare position: number;
	@doc.date declare publishedAt: Dayjs;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;

	getTitle(lang: string) {
		return this.getTranslation<string, string>('title', lang, '');
	}
}
